import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=d37e6878&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=js&"
export * from "./Paging.vue?vue&type=script&lang=js&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=d37e6878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37e6878",
  null
  
)

export default component.exports